import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IDecisionModalProps } from './decisionModalHelper';

/**
 * Starts the resubmission wizard directly instead of opening a confirmation
 * modal. The decision sidebars still use the decision component registry, so
 * this action closes that selection and navigates into the wizard here.
 */
export const ResubmitAction = ({ onClose }: IDecisionModalProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    onClose();
    navigate('?submissionType=resubmit');
  }, [navigate, onClose]);

  return null;
};
